{
  "dojo": "silver",
  "label": "Silver Coast Dojo",
  "notice": "Current regular class schedule.",
  "classes": [
    {
      "day": "tuesday",
      "start": "16:30",
      "title": "Kids 1",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 4–6 · 45 min",
      "coach": "Team Tiago"
    },
    {
      "day": "tuesday",
      "start": "17:40",
      "title": "Kids 2",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 7–12",
      "coach": "Team Tiago"
    },
    {
      "day": "tuesday",
      "start": "18:45",
      "title": "Adults BJJ",
      "audience": "adults",
      "format": "Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "10:15",
      "title": "Women Only",
      "audience": "women",
      "format": "BJJ",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "16:30",
      "title": "Kids 1",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 4–12 · 45 min",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "17:40",
      "title": "Girls Only",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 9–12",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "18:45",
      "title": "Adults BJJ",
      "audience": "adults",
      "format": "Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "16:30",
      "title": "Kids 1",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 4–6 · 45 min",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "17:40",
      "title": "Kids 2",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 7–12",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "18:45",
      "title": "Adults BJJ",
      "audience": "adults",
      "format": "Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    }
  ],
  "notice_de": "Aktueller regulärer Stundenplan.",
  "future_schedule": {
    "publish_date": "2026-08-14",
    "effective_date": "2026-08-17",
    "notice": "Current regular class schedule.",
    "notice_de": "Aktueller regulärer Stundenplan.",
    "classes": [
      {
        "day": "monday",
        "start": "17:00",
        "title": "Kids Competition / Drills",
        "title_de": "Kids Competition / Drills",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Competition team",
        "level_de": "Wettkampfteam"
      },
      {
        "day": "monday",
        "start": "18:00",
        "title": "BJJ Fundamentals (Gi)",
        "title_de": "BJJ Fundamentals (Gi)",
        "audience": "adults",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Fundamentals",
        "level_de": "Fundamentals"
      },
      {
        "day": "tuesday",
        "start": "15:00",
        "title": "Kids BJJ (No-Gi)",
        "title_de": "Kids BJJ (No-Gi)",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Ages 3–4",
        "level_de": "3–4 Jahre"
      },
      {
        "day": "tuesday",
        "start": "16:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 5–6",
        "level_de": "5–6 Jahre"
      },
      {
        "day": "tuesday",
        "start": "17:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 7–12",
        "level_de": "7–12 Jahre"
      },
      {
        "day": "tuesday",
        "start": "18:00",
        "title": "BJJ All Levels (No-Gi)",
        "title_de": "BJJ All Levels (No-Gi)",
        "audience": "adults",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "tuesday",
        "start": "19:00",
        "title": "Muay Thai / Kickboxing / Striking",
        "title_de": "Muay Thai / Kickboxing / Striking",
        "audience": "mma",
        "format": "Striking",
        "format_de": "Striking",
        "level": "All levels · 90 min",
        "level_de": "Alle Levels · 90 Min."
      },
      {
        "day": "wednesday",
        "start": "10:15",
        "title": "Women Only BJJ (Gi)",
        "title_de": "Women Only BJJ (Gi)",
        "audience": "women",
        "format": "Gi",
        "format_de": "Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "wednesday",
        "start": "16:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 6–12",
        "level_de": "6–12 Jahre"
      },
      {
        "day": "wednesday",
        "start": "17:00",
        "title": "Girls Only BJJ (Gi)",
        "title_de": "Girls Only BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Girls ages 7–12",
        "level_de": "Mädchen 7–12 Jahre"
      },
      {
        "day": "wednesday",
        "start": "18:00",
        "title": "BJJ All Levels (No-Gi)",
        "title_de": "BJJ All Levels (No-Gi)",
        "audience": "adults",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "thursday",
        "start": "17:00",
        "title": "Kids Competition / Drills",
        "title_de": "Kids Competition / Drills",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Competition team",
        "level_de": "Wettkampfteam"
      },
      {
        "day": "thursday",
        "start": "18:00",
        "title": "BJJ Fundamentals (Gi)",
        "title_de": "BJJ Fundamentals (Gi)",
        "audience": "adults",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Fundamentals",
        "level_de": "Fundamentals"
      },
      {
        "day": "thursday",
        "start": "19:00",
        "title": "Muay Thai / Kickboxing / Striking",
        "title_de": "Muay Thai / Kickboxing / Striking",
        "audience": "mma",
        "format": "Striking",
        "format_de": "Striking",
        "level": "All levels · 90 min",
        "level_de": "Alle Levels · 90 Min."
      },
      {
        "day": "friday",
        "start": "16:00",
        "title": "Kids BJJ (No-Gi)",
        "title_de": "Kids BJJ (No-Gi)",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Ages 5–6",
        "level_de": "5–6 Jahre"
      },
      {
        "day": "friday",
        "start": "17:00",
        "title": "Kids BJJ (No-Gi)",
        "title_de": "Kids BJJ (No-Gi)",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Ages 7–12",
        "level_de": "7–12 Jahre"
      },
      {
        "day": "friday",
        "start": "18:00",
        "title": "BJJ / No-Gi Sparring (Gi / No-Gi)",
        "title_de": "BJJ / No-Gi Sparring (Gi / No-Gi)",
        "audience": "adults",
        "format": "Gi / No-Gi",
        "format_de": "Gi / No-Gi",
        "level": "Sparring",
        "level_de": "Sparring"
      },
      {
        "day": "friday",
        "start": "19:00",
        "title": "Muay Thai / Kickboxing / Striking Sparring",
        "title_de": "Muay Thai / Kickboxing / Striking Sparring",
        "audience": "mma",
        "format": "Striking",
        "format_de": "Striking",
        "level": "Sparring · 90 min",
        "level_de": "Sparring · 90 Min."
      },
      {
        "day": "saturday",
        "start": "10:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 6–12",
        "level_de": "6–12 Jahre"
      },
      {
        "day": "saturday",
        "start": "11:00",
        "title": "BJJ / No-Gi Sparring (Gi / No-Gi)",
        "title_de": "BJJ / No-Gi Sparring (Gi / No-Gi)",
        "audience": "adults",
        "format": "Gi / No-Gi",
        "format_de": "Gi / No-Gi",
        "level": "Sparring",
        "level_de": "Sparring"
      }
    ]
  }
}
